import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const BUTTON_HOVER = { scale: 1.05 };
const BUTTON_TAP = { scale: 0.95 };

export const HeroButtons = ({ t, language, onScrollTo }) => (
  <>
    <motion.button
      whileHover={BUTTON_HOVER}
      whileTap={BUTTON_TAP}
      onClick={() => onScrollTo('contact')}
      data-testid="hero-cta-contact-btn"
      className="group px-8 py-4 rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold shadow-lg shadow-orange-500/50 hover:shadow-xl hover:shadow-orange-500/60 transition-shadow flex items-center justify-center space-x-2"
    >
      <span>{t.hero.cta}</span>
      <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
    </motion.button>
    <motion.button
      whileHover={BUTTON_HOVER}
      whileTap={BUTTON_TAP}
      onClick={() => onScrollTo('brands')}
      data-testid="hero-cta-brands-btn"
      className="px-8 py-4 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold hover:bg-white/20 transition-colors"
    >
      {language === 'tr' ? 'Güvenilir Partnerlerimiz' : 'Trusted Partners'}
    </motion.button>
  </>
);
